import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AddPurchaseComponent} from '@app/modules/purchase/add-purchase/add-purchase.component';
import {PurchaseListComponent} from '@app/modules/purchase/purchase-list/purchase-list.component';
import {PurchaseReturnComponent} from '@app/modules/purchase/purchase-return/purchase-return.component';
import {PurchaseReturnListComponent} from '@app/modules/purchase/purchase-return-list/purchase-return-list.component';
import {AddDamageComponent} from '@app/modules/purchase/add-damage/add-damage.component';
import {DamageListComponent} from '@app/modules/purchase/damage-list/damage-list.component';
import {WarehouseReportComponent} from '@app/modules/purchase/warehouse-report/warehouse-report.component';
import {AuthGuard} from '@app/shared';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'add-purchase',
        loadComponent: () => AddPurchaseComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/add-purchase'}
      },
      {
        path: 'purchase-list',
        loadComponent: () => PurchaseListComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/purchase-list'}
      },
      {
        path: 'purchase-return',
        loadComponent: () => PurchaseReturnComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/purchase-return'}
      },
      {
        path: 'purchase-return-list',
        loadComponent: () => PurchaseReturnListComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/purchase-return-list'}
      },
      {
        path: 'add-damage',
        loadComponent: () => AddDamageComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/add-damage'}
      },
      {
        path: 'add-damage/:/:id',
        loadComponent: () => AddDamageComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/add-damage'}
      },
      {
        path: 'damage-list',
        loadComponent: () => DamageListComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/damage-list'}
      },
      {
        path: 'warehouse-report',
        loadComponent: () => WarehouseReportComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/warehouse-report'}
      },
      {
        path: 'warehouse-report/:id',
        loadComponent: () => WarehouseReportComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/warehouse-report'}
      },
    ],
    runGuardsAndResolvers: 'always',
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PurchaseRoutingModule {
}
